import { PageControl } from "@app-model/page-control";
import { UfLabel } from "@app-model/state";
import { DateUtils } from "@app-utils/DateUtils";

export type CommissionPeriodDate = "SALE" | "PAYMENT";

export type CommissionPaymentGateway = "IUGU" | "SUPERBID_PAY" | null;

export class ComissionReportRequest {
  items?: PageHelpComissionReport;
  latePayments?: number;
  notPaid?: number;
  paid?: number;
}

export class CommissionReportConsolidated {
  latePayment: number;
  notPaid: number;
  paid: number;

  paidIUGU?: number;
  paidsbXPay?: number;
  paidWithoutGateway?: number;
  notPaidIUGU?: number;
  notPaidSbXPay?: number;
  notPaidWithoutGateway?: number;
  latePaymentIUGU?: number;
  latePaymentSbXPay?: number;
  latePaymentWithoutGateway?: number;

  comissionValueCentsPaidIUGU?: number;
  comissionValueCentsPaidSbXPay?: number;
  comissionValueCentsPaidWithoutGateway?: number;

  comissionValueCentsPeriodIUGU?: number;
  comissionValueCentsPeriodSbXPay?: number;
  comissionValueCentsPeriodWithoutGateway?: number;

  comissionValueCentsLateIUGU?: number;
  comissionValueCentsLateSbXPay?: number;
  comissionValueCentsLateWithoutGateway?: number;
  comissionValueCentsOpenIUGU?: number;
  comissionValueCentsOpenSbXPay?: number;
  comissionValueCentsOpenWithoutGateway?: number;
}
export class AuctionStatsRequest {
  items?: PageHelpAuction;
  summary?: AuctionStatsHelper;
}

export class PageHelpAuction {
  actualPage?: number;
  data?: AuctionStatsReportItem[];
  numberOfPages?: number;
  totalElements?: number;
}

export class PageHelpComissionReport {
  actualPage?: number;
  data?: CommissionReportItem[];
  numberOfPages?: number;
  totalElements?: number;
}

export class AuctionStatsReportItem {
  make?: string;
  manufactureYear?: number;
  model?: string;
  modelYear?: number;
  numberPlate?: string;
  stats?: AuctionStatsHelper;
  status?: string;
  trim?: string;
  vehicleId?: string;
  oemDealerId?: string;
  oemDealerName?: string;
}

export enum AuctionStatsItemStatusEnum {
  "SOLD" = "VENDIDO",
  "WITH_CURRENT_BID" = "COM LANCE ATUAL",
  "ACTIVE" = "ATIVO",
  "INACTIVE" = "INATIVO",
}

// Rename
export class CommissionReportItem {
  bankslipUrl?: string;
  comissionValueCents?: number;
  dealerId?: string;
  dealerName?: string;
  expirationDate?: string;
  id?: string;
  latePayment?: boolean;
  latePaymentDate?: Date;
  firstLatePaymentDate?: Date;
  make?: string;
  manufactureYear?: number;
  model?: string;
  modelYear?: number;
  numberPlate?: string;
  oemDealerId?: string;
  oemDealerName?: string;
  paid?: boolean;
  price?: number;
  soldAt?: string;
  trim?: string;
  vehicleId?: string;
  comissionPaidAt?: string | Date;
  paymentGateway?: CommissionPaymentGateway;

  isDiffFirstLatePaymentDate(): boolean {
    return this.firstLatePaymentDate && this.latePaymentDate && !DateUtils.isSameDay(this.firstLatePaymentDate, this.latePaymentDate);
  }
}

export class AuctionStatsHelper {
  acceptedPersonalizedOffers?: number;
  activeBids?: number;
  bids?: number;
  bought?: number;
  cancelledBuy?: number;
  favorites?: number;
  impressions?: number;
  lastStatDate?: string;
  personalizedOffers?: number;
  rejectedPersonalizedOffers?: number;
  uniqueImpressions?: number;
  uniqueViews?: number;
  views?: string;
}

export class ComissionReportFilter {
  dealerId?: string;
  end?: Date;
  ini?: Date;
  listOnlyNotPaid?: boolean;
  oemDealerId?: string;
  myVehicles: boolean;
  pageControl?: PageControl;
  status?: string;
  query?: any;
  commissionPeriodDate?: CommissionPeriodDate | null;
  paymentGateway?: CommissionPaymentGateway;
}

export class AuctionStatsReportFilter {
  dealerId?: string;
  end?: Date;
  ini?: Date;
  oemDealerId?: string;
  pageControl?: PageControl;
  statTypes?: string[];
}

export class DealerInfoHelper {
  city?: string;
  cpfCnpj?: string;
  emails?: string[];
  id?: string;
  name?: string;
  phoneNumbers?: string[];
  uf?: string;
}

export class OemDealerHelper {
  id?: string;
  name?: string;
}

export class BankslipActionResponse {
  errorCode?: string;
  message?: string;
  success?: boolean;
}

export enum BankslipActionResponseEnum {
  "OK" = "Operação realizada com sucesso.",
  "NOT_SOLD" = "Ocorreu uma falha: Veículo não vendido.",
  "IUGU_EXCEPTION" = "Ocorreu uma falha: Erro no sistema IUGU.",
  "ALREADY_CREATED" = "Boleto já criado.",
  "ALREADY_PAID" = "Boleto já pago.",
  "NOT_FOUND" = "Veículo não encontrado",
  "NOT_EXPIRED" = "Boleto não expirado ainda.",
  "ADMIN_ONLY" = "Operação permitida apenas para administradores.",
}

export const auctionStatsStatus = [
  {
    label: "Vendido",
    value: "SOLD",
  },
  {
    label: "Arrematando",
    value: "WITH_CURRENT_BID",
  },
  {
    label: "Ativo",
    value: "ACTIVE",
  },
  { label: "Inativo", value: "INACTIVE" },

];
